import { FieldStyles } from '@shared/scenes/cards/collectionView/components/fields/CardCollectionViewField';
import { grid } from '@shared/styles';

export const headerFieldStyles: FieldStyles = {
  addressStyle: { width: '100%' },
  dateStyle: { width: '100%', paddingVertical: grid(1) },
  dateRangeStyle: { width: '100%', paddingVertical: grid(1) },
  emailStyle: { width: '100%' },
  fileStyle: { width: '100%' },
  geolocationStyle: { width: '100%' },
  numberStyle: { width: '100%' },
  personStyle: { width: '100%' },
  relatedCardStyle: { width: '100%' },
  signatureStyle: { width: '100%' },
  subformStyle: { width: '100%' },
  tagStyle: { width: '100%' },
  textFieldStyle: { width: '100%', paddingRight: grid(3) },
  timeTrackerStyle: { width: '100%' },
  todoStyle: { width: '100%' },
  urlStyle: { width: '100%', paddingVertical: grid(0.5) },
  inputButtonStyle: { width: '100%' },
  entityBatchStyle: { width: '100%' },
};

export const wideCardFieldStyles: FieldStyles = {
  addressStyle: { maxWidth: 300 },
  dateStyle: { maxWidth: 300, paddingVertical: grid(1) },
  dateRangeStyle: { maxWidth: 300, paddingVertical: grid(1) },
  emailStyle: { maxWidth: 300 },
  fileStyle: { maxWidth: 300 },
  geolocationStyle: { maxWidth: 300 },
  numberStyle: { maxWidth: 300 },
  personStyle: { maxWidth: 300 },
  relatedCardStyle: { maxWidth: 300 },
  signatureStyle: { maxWidth: 300 },
  subformStyle: { maxWidth: 300 },
  tagStyle: { maxWidth: 300 },
  tagItemStyle: { maxWidth: grid(25) },
  textFieldStyle: { maxWidth: 300 },
  timeTrackerStyle: { maxWidth: 300 },
  todoStyle: { maxWidth: 300 },
  urlStyle: { maxWidth: 300, paddingVertical: grid(0.5) },
  urlTextStyle: { fontSize: 16 },
  inputButtonStyle: { maxWidth: 300 },
  entityBatchStyle: { maxWidth: 300 },
};

export const narrowCardFieldStyles: FieldStyles = {
  addressStyle: { maxWidth: '100%', marginBottom: -grid(0.5) },
  dateStyle: { maxWidth: '100%', paddingVertical: grid(1) },
  emailStyle: { maxWidth: '100%' },
  fileStyle: { maxWidth: '100%', marginBottom: -grid(1) },
  geolocationStyle: { maxWidth: '100%', marginBottom: grid(1) },
  numberStyle: { maxWidth: '100%' },
  personStyle: { maxWidth: '100%' },
  relatedCardStyle: { maxWidth: '100%' },
  signatureStyle: { maxWidth: '100%', marginBottom: grid(1) },
  subformStyle: { maxWidth: '100%', marginBottom: -grid(1) },
  tagStyle: { maxWidth: '100%' },
  textFieldStyle: { maxWidth: '100%' },
  timeTrackerStyle: { maxWidth: '100%' },
  todoStyle: { maxWidth: '100%', marginBottom: -grid(1) },
  urlStyle: { paddingVertical: grid(0.5) },
  urlTextStyle: { fontSize: 16 },
  inputButtonStyle: { maxWidth: '100%' },
  entityBatchStyle: { maxWidth: '100%' },
};
